
/**
 * this is a hack - but it fixes a bug in semantic ui react.  IF you're sitting on a page with a modal open, then refresh the page, there is a scrolling issue that happens and it doesn't allow you to scroll down the modal.  This code below corrects that by running only if the referrer is the current href. 
 */
export const resetSemanticModalBugFix_h = ()=>{
    setTimeout(()=>{
        const anotherModal = document.getElementsByClassName('ui page modals').length;
        if (anotherModal > 0) document.body.classList.add('scrolling', 'dimmable', 'dimmed');
    }, 50)
};